// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__3QsPi","annotation":"footer_annotation__11tyL","logo":"footer_logo__3divc"};